import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild, HostListener, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ElasticExpedientesByKeyword } from '../../core/model/inventories';
import { Notifications } from '../../core/model/notifications';
import { Config } from '../../core/model/service-config';
import { AlertasService } from '../../core/services/alertas.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ServiceConfigService } from '../../core/services/service-config.service';
import { SessionService } from '../../core/services/session.service';
import { ShoppingElementsService } from '../../core/services/shopping-elements.service';
import { InventariosService } from '../../core/services/inventarios.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewChecked, AfterViewInit {
  @ViewChild('divNavBarOptions') divNavBarOptions: ElementRef;
  @ViewChild('divInventorySearch') divInventorySearch: ElementRef;
  @ViewChild('divOptionHeader') divOptionHeader: ElementRef;
  username: string;
  nombreCliente: string;
  idcliente: number;
  isLoggedIn$: Observable<boolean>;
  tieneInventario = false;

  notificationPending: number;
  importantNotificationPending: number;

  private isLoggedUser: boolean;

  hasInitialData: boolean;

  config: Config;

  numElementsShoppingCart: number;

  @HostListener('window:resize')
  onResize() {
    this.onResizedNavBar();
  }


  constructor(
    private authService: AuthenticationService,
    private alertasService: AlertasService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private configService: ServiceConfigService,
    private shoppingElementsService: ShoppingElementsService,
    private sessionService: SessionService,
    private inventoryService: InventariosService
  ) { }

  public addingConsulta(): boolean {
    return this.inventoryService.isCalledFromConsultas();
  }

  ngOnInit() {
    this.isLoggedIn$ = this.authService.isLoggedIn();

    this.isLoggedIn$.subscribe((logged: boolean) => {
      this.isLoggedUser = logged;
    });

    this.authService.getClienteName$().subscribe(data => {
      this.nombreCliente = data;
    });

    this.authService.getUserName().subscribe(data => {
      this.username = data;
    });

    this.idcliente = this.sessionService.getClientId();

    this.authService.getNotificationPending().subscribe(data => {
      this.notificationPending = data;
    });

    this.authService.getImportantNotificationPending().subscribe(data => {
      this.importantNotificationPending = data;
    });

    this.authService.getTieneInventario().subscribe(data => {
      this.tieneInventario = data;
    });

    // convertimos minutos en milisegundos.
    const reloadNotificationsMilliseconds = environment.MINUTES_RELOAD_NOTIFICATIONS * 60 * 1000;

    interval(reloadNotificationsMilliseconds).subscribe(x => {
      if (this.isLoggedUser) {
        this.alertasService.getNotificationsPendingRead()
          .subscribe((data: Notifications) => {
            this.authService.setNotificationPending(data.NotificacionesPendientesLeer);
            this.authService.setImportantNotificationPending(data.NotificacionesImportantesPendientesLeer);
          });
      }
    });

    this.shoppingElementsService.totalElements$
      .subscribe((numTotalElements: number) => {
        this.numElementsShoppingCart = numTotalElements;
      });

    this.authService.clientHasInitialData().subscribe(hasInitialData => {
      this.hasInitialData = hasInitialData;
      if (this.hasInitialData) {
        this.config = this.configService.getServiceConfig();
      } else {
        this.config = undefined;
      }
    });

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    this.onResizedNavBar(true);
  }

  onLogout() {
    this.authService.logout();
  }

  navigateToRecords(search: ElasticExpedientesByKeyword) {
    this.router.navigate(['docout', {
      outlets: {
        contenido: ['inventarios', search.PALABRAS_CLAVE.join(' '), {
          operator: search.OPERADOR,
          inventoryType: 'inventarios',
          idGrupo: search.idGrupo
        }]
      }
    }]);
  }

  private onResizedNavBar(first: boolean = false) {
    setTimeout(() => {
      if (this.divInventorySearch) {
        const totalWidth = this.divNavBarOptions.nativeElement.offsetWidth;
        const widthOptions = this.divOptionHeader.nativeElement.offsetWidth;
        // Aplicamos 20 px de margen entre un div y otro.
        this.divInventorySearch.nativeElement.style.setProperty('width', (totalWidth - widthOptions - 20) + 'px');
        if (first) {
          setTimeout(() => {
            this.onResizedNavBar(false);
          }, 5000);
        }
      }
    }, first ? 3000 : 50);
  }

}
